// extracted by mini-css-extract-plugin
module.exports = {"auto_search":"auto_search-8BA-rsFl","txt":"txt-nyXHcw9c","btn":"btn-3sxZmARa"};